import Show from '../show'

function UbConsumptionDashboard() {
  return (
    <Show
      title="Utility Billing — Consumption Dashboard"
      dashboardKey="ub_consumption_dashboards"
      showYear={false}
    />
  )
}

export default UbConsumptionDashboard
